<template>
	<div v-bind:class="'events-' + listFormat()"> 
		<event-hero v-if="showhero === true"></event-hero>

		<section class="section filter-section" v-bind:class="contentBackground()">
			<event-filters v-if="filters.Radius !== undefined && showfilters === true" v-bind:filters="filters" v-bind:secondaryfilters="secondaryFilters" v-bind:shownationwide="shownationwide"></event-filters>
		</section>

		<section class="cards card--list section">
			<div class="global-container">
				<div class="event-list-row row">
					<div class="event-list-toggle-btn hide-desktop">
						<p><strong>Event Type</strong></p>
						<button class="btn primary-btn js-toggle-category-menu" type="button"><span class="inner-text">Select Events</span> <span class="icon-angle-down"></span></button>
					</div>
					<div class="sidebar-checkboxes js-category-menu">
						<event-categories v-if="showCategories() && eventType() == 'fundraising'" v-on:change="categoryChange()"></event-categories>
						<event-program-categories v-if="showCategories() && eventType() == 'program'" v-on:change="categoryChange()"></event-program-categories>
					</div>

					<div class="event-items-wrapper" v-if="listing.length > 0">
						<fragment>
							<h2 class="state-selected-events">{{this.selectedStatesDisplayname}}</h2>
						</fragment>
						<fragment v-if="listFormat() == 'standard'">
							<event-item v-for="(item) in listing" v-bind:item="item" v-bind:key="item.DetailID" v-bind:showctatext="showctatext" v-bind:displaySummary="displaySummary"></event-item>
						</fragment>
						<fragment v-if="listFormat() == 'sidebyside'">
							<div class="row">
								<div class="col-12 col-lg-6">
									<div class="events-map">
										<event-map></event-map>
									</div>
								</div>
								<div class="col-12 col-lg-6 card--list">
									<div class="">
										<fragment v-if="cardFormat() == 'standard'">
											<event-item-minimal v-for="(item) in listing"
																v-bind:item="item"
																v-bind:key="item.DetailID"
																v-bind:showctatext="showctatext"
																v-bind:ctatext="cardcta"></event-item-minimal>
										</fragment>
										<fragment v-if="cardFormat() == 'address'">
											<event-item-address v-for="(item) in listing"
																v-bind:item="item"
																v-bind:key="item.DetailID"
																v-bind:showctatext="showctatext"
																v-bind:ctatext="cardcta"></event-item-address>
										</fragment>
									</div>
								</div>
							</div>
						</fragment>

						<section class="padding-top padding-bottom pagination" v-if="pagination && pagination.totalPages > 1" v-bind:class="contentBackground()">
							<div class="global-container">
								<pagination></pagination>
							</div>
						</section>

					</div>

					<div class="event-items-wrapper no-result" v-else v-bind:class="contentBackground()">
						<fragment v-if="noresultsmsg">
							<richtext-content></richtext-content>
						</fragment>
						<fragment v-else>
							<h2 class="state-selected-events">{{this.selectedStatesDisplayname}}</h2>
							<h3 class="not-found-heading h4 display">
								Sorry, no results were found matching your specifications.
							</h3>
							<p>
								Try selecting a different state or adjusting the zip code radius.
							</p>
						</fragment>
					</div>

				</div>
			</div>
		</section>

	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex';
	import Pagination from '../components/listing/pagination-dropdown';
	import EventItem from '../components/event/event-item';
	import EventItemMinimal from '../components/event/event-item-minimal';
	import EventItemAddress from '../components/event/event-item-address';
	import EventCategories from '../components/event/event-categories';
	import EventProgramCategories from '../components/event/event-categories-program';
	import EventMap from '../components/event/event-map-isolated';
	import EventHero from '../components/event/event-hero';
	import EventFilters from '../components/event/event-filters';
	import eventListFilter from '../filters/event-list-filter';
	import archivefilterDates from '../filters/archive-filter-dates';
    import acrcListFilter from '../filters/acrc-list-filter';
    import RichTextContent from '../components/layout/richtext-content';
	import * as CONST from '../utils/constants';

	export default {
		props: ['filterid',
			'filtertype',
			'result',
			'resource',
			'showhero',
			'showfilters',
			'hidecategories',
			'eventpagetype',
			'shownationwide',
			'showctatext',
			'eventstyle',
			'cardstyle',
			'cardcta',
			'noresultsmsg'
			],
		data: function () {
			return {
				includedatefilter: CONST.globalProject.DisplayDateFilter || false,
				hidefilterbar: CONST.globalProject.HideFilterBar || false,
				displaySummary: CONST.globalProject.DisplayListingSummary || false,
				filters: {},
				secondaryFilters: null,
				selectedStatesDisplayname: "",
			}
		},
		computed: mapState({
			loading: state => state.listing.loading,
			listing: state => state.listing.listing,
			pagination: state => state.listing.pagination,
			specification: state => state.listing.specification,
		}),
		components: {
			pagination: Pagination,
			'event-item': EventItem,
			'event-item-minimal': EventItemMinimal,
			'event-item-address': EventItemAddress,
			'event-hero': EventHero,
			'event-categories': EventCategories,
			'event-program-categories': EventProgramCategories,
			'event-filters': EventFilters,
			'event-map': EventMap,
			'richtext-content': RichTextContent
		},
		mounted: function () {
			let _this = this;
			document.onreadystatechange = () => {
				if (document.readyState == "complete") {
					let stateDisplayName = $('[data-id="form-StateCode"]').attr("title");
					//this.selectedStatesDisplayname = $('[data-id="form-StateCode"]').attr("title");
					if(stateDisplayName.indexOf("All States") >= 0){
						this.selectedStatesDisplayname = "Nationwide Events";
					}else{
						this.selectedStatesDisplayname = stateDisplayName + " Events";
					}

					$('#form-StateCode').on('change', function() {
							let stateDisplayNameChange = $('[data-id="form-StateCode"]').attr("title");
							//this.selectedStatesDisplayname = $('[data-id="form-StateCode"]').attr("title");
							if(stateDisplayNameChange.indexOf("All States") >= 0){
								stateDisplayNameChange = "Nationwide Events";
								$(".state-selected-events").text(stateDisplayNameChange);
							}else{
								stateDisplayNameChange = stateDisplayNameChange + " Events";
								$(".state-selected-events").text(stateDisplayNameChange);
							}
					});
				}
			}
			// take props and send to vuex store
			this.setInitData(this.result);

            if (this.filtertype == "acrc") {
                this.filters = acrcListFilter;
            } else if (this.filtertype == "eventwidgetfilter") {
                this.filters = eventListFilter;
				this.secondaryFilters = archivefilterDates;
			} else {
                this.filters = eventListFilter;
			}

			if (this.hidefilterbar == "true") {
				this.showfilters = false;
			} else {
				this.showfilters = true;
			}

			// show date filter for scheduled events
			//if (this.filtertype === 'eventwidgetfilter' && this.showfilters === 'true' && this.includedatefilter === 'true') {
				//if (Object.keys(archivefilterDates).length) {
					//this.secondaryFilters = archivefilterDates;
				//}
			//}

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			});

			this.$store.subscribeAction((action, state) => {
				if (action.type === 'listing/setEventFilter') {
					$('html, body').animate({
						scrollTop: $('.filter-app').offset().top
					}, 1000);
				}
			});

			// if each spec change should trigger a new api call, use this. else manually call setFilter action on button click
			this.$store.subscribe((mutation, state) => {
				if (
					mutation.type === 'listing/updateSpecification' &&
					(mutation.payload.key !== 'Radius' || (mutation.payload.key === 'Radius' && state.listing.specification.Zipcode !== null && state.listing.specification.Zipcode !== undefined && state.listing.specification.Zipcode !== ''))
				) {
					this.setEventFilter();
				};
				console.log(this.listing);
			});
		},
		methods: {
			...mapActions('listing', { setEventFilter: 'setEventFilter' }),
			...mapMutations('listing', { setInitData: 'setInitData' }),
			showCategories: function() {
				if (this.filtertype == 'eventwidgetfilter') {
					return false;
				}
				if (this.hidecategories) {
					return false;
				}
				return true;
			},
			contentBackground: function() {
				if (this.filtertype == 'eventwidgetfilter') {
					return 'bg-white';
				}
				return 'bg-white';
			},
			listFormat: function() {
				if (this.eventstyle) {
					return this.eventstyle;
				}
				return 'standard';
			},
			cardFormat: function() {
				if (this.cardstyle) {
					return this.cardstyle;
				}
				return "standard";
			},
			eventType: function() {
				if (this.eventpagetype == 'program') {
					return 'program';
				}
					return 'fundraising';
			},
        },
    }
</script>
